
<div id="main">
    <div class="toolbar-container" style="box-shadow: none; background-color: #eaf1f5;">
        <div class="" style="box-shadow: 0px 4px 4px #0000001f;">
            <ng-container *ngIf="is_openSearch">
                <div [formGroup]="searchForm" class="input-wrap"
                    style="display: inline-block; filter:none;background-color:white;">
                    <div class="d-flex m-3"
                        style="  border-radius: 10px; height:50px;box-shadow: 0px 4px 4px #0000001f;">
                        <div style="width: 40px;">
                            <span class="wraped-input-icon">
                                <span class="material-icons-outlined">
                                    search
                                </span>
                            </span>
                        </div>
                        <div style="flex-grow: 1;">
                            <input formControlName="search" type="text" placeholder="Search ..." class="form-control"
                                style="height: 100%; width: 100%; box-shadow: none !important; border: none; background-color: transparent;">
                        </div>
                        <div class="d-flex" style="width: 50px;">
                            <button
                                style="background: none; border: none; cursor: pointer; padding: 0; margin-left: 5px;"
                                aria-label="Clear search" (click)="clearSearch()">
                                <i class="fa fa-times" style="font-size: 16px; color: #000;"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="isExpandFilter">

                <div [formGroup]="filterForm" class="input-wrap"
                    style="display: inline-block; filter:none;background-color: white;">
                    <div class="m-3 d-flex flex-column" style="gap: 0.5rem;">

                        <div class="row no-gutters ">
                            <div class="col-12">
                                <ng-select [items]="saleTypeFilters" formControlName="saleType" bindLabel="key"
                                    bindValue="value" [clearable]="false" placeholder="Select Sale Filter"
                                    appendTo="body">
                                </ng-select>
                            </div>
                        </div>

                        <!-- Date FILTER -->
                        <div class="row no-gutters ">
                            <div class="col-12">
                                <ng-select [items]="dateFilters" formControlName="date" bindLabel="label"
                                    bindValue="value" [clearable]="true" placeholder="Select Date Filter"
                                    appendTo="body">
                                </ng-select>
                            </div>
                        </div>

                        <!-- DATE FILTER -->
                        <div class="row no-gutters" *ngIf="filterForm.get('date')?.value === 'custom'">
                            <div class="col-6 pr-1">
                                <input formControlName="fromDate" class="form-control" type="date">
                            </div>
                            <div class="col-6 pl-1">
                                <input formControlName="toDate" class="form-control" type="date">
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end " style="gap:0.5rem;">
                            <button (click)="clearFilter()" class="btn btn-outline-secondary w-100">Clear
                                Filter</button>
                            <button (click)="applyFilter()" class="btn btn-primary w-100">Apply Filter</button>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class="bg-white border-top">
                <div class="px-3 py-2">
                    <div class="input-wrap d-flex flex-column filter-block">
                        <div class="d-flex flex-column content ">

                            <div *ngIf="summaryLoading; else realSummaryContent" class="d-flex align-items-center justify-content-between py-2 px-3">
                                <div class="d-flex flex-column align-items-center justify-content-center text-center" style="width: 33%;">
                                    <div class="d-flex justify-content-center mb-1">
                                        <div class="skeleton-text short " style="height: 20px; width: 80px;"></div>
                                    </div>
                                    <div class="skeleton-text very-short" style="margin-top: -6px;width: 60px;"></div>
                                </div>

                                <div class="d-flex flex-column align-items-center justify-content-center text-center" style="width: 33%;">
                                    <div class="d-flex justify-content-center mb-1">
                                        <div class="skeleton-text short" style="height: 20px; width: 80px;"></div>
                                    </div>
                                    <div class="skeleton-text very-short" style="margin-top: -6px; width: 60px;"></div>
                                </div>
                            
                                <div class="d-flex flex-column align-items-center justify-content-center text-center" style="width: 33%;">
                                    <div class="d-flex justify-content-center mb-1">
                                        <div class="skeleton-text short" style="height: 20px; width: 80px;"></div>
                                    </div>
                                    <div class="skeleton-text very-short" style="margin-top: -6px; width: 60px;"></div>
                                </div>
                            
                            </div>

                            <ng-template #realSummaryContent>
                                <div class="d-flex align-items-center justify-content-between py-2 px-3">
                                    <div class=" d-flex flex-column text-center">
                                        <div class="d-flex justify-content-center">
                                            <div>
                                                <h5>{{summary?.OrderDeliveredTotalValue != null ? (summary?.OrderDeliveredTotalValue | currency : 'INR' : 'symbol' : '1.0-0') : '--'}}</h5>
                                            </div>
                                        </div>
                                        <div class="text-success" style="font-size: 13px; margin-top: -6px;">Sales<span style="color: #000;">({{salesData?.length}})</span>
                                        </div>
                                    </div>
    
                                    <div class=" d-flex flex-column text-center">
                                        <div class="d-flex justify-content-center">
                                            <div>
                                                <h5>{{summary?.TotalCollection != null ? (summary?.TotalCollection | currency : 'INR' : 'symbol' : '1.0-0') : '--'}}</h5>
                                            </div>
                                        </div>
                                        <div class="text-success" style="font-size: 13px; margin-top: -6px;">Collections<span style="color: #000;">({{salesData?.length}})</span>
                                        </div>
                                    </div>
    
                                    <div class=" d-flex flex-column text-center">
                                        <div class="d-flex justify-content-center">
                                            <div>
                                                <h5>{{summary?.TotalCreditValue != null ? (summary?.TotalCreditValue | currency : 'INR' : 'symbol' : '1.0-0') : '--'}}</h5>
                                            </div>
                                        </div>
                                        <div class="text-success" style="font-size: 13px; margin-top: -6px;">Credit<span style="color: #000;">({{salesData?.length}})</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>

                            <div *ngIf="isSummaryExpanded"
                                class="d-flex  align-items-center justify-content-between py-2 px-3">
                                <div class=" d-flex flex-column text-center">
                                    <div class="d-flex justify-content-center">
                                        <div>
                                            <h6>{{summary?.TotalCashValue != null ? (summary?.TotalCashValue | currency : 'INR' : 'symbol' : '1.0-0') : '--'}}</h6>
                                        </div>
                                    </div>
                                    <div class="text-success" style="font-size: 13px; margin-top: -6px;">Cash<span style="color: #000;">({{salesData?.length}})</span>
                                    </div>
                                </div>

                                <div class=" d-flex flex-column text-center">
                                    <div class="d-flex justify-content-center">
                                        <div>
                                            <h6>{{summary?.TotalUPIValue != null ? (summary?.TotalUPIValue | currency : 'INR' : 'symbol' : '1.0-0') : '--'}}</h6>
                                        </div>
                                    </div>
                                    <div class="text-success" style="font-size: 13px; margin-top: -6px;">UPI<span style="color: #000;">({{salesData?.length}})</span>
                                    </div>
                                </div>

                                <div class=" d-flex flex-column text-center">
                                    <div class="d-flex justify-content-center">
                                        <div>
                                            <h6>{{summary?.TotalCardValue != null ? (summary?.TotalCardValue | currency : 'INR' : 'symbol' : '1.0-0') : '--'}}</h6>
                                        </div>
                                    </div>
                                    <div class="text-success" style="font-size: 13px; margin-top: -6px;">Card<span style="color: #000;">({{salesData?.length}})</span>
                                    </div>
                                </div>
                            </div>

                            <button class="d-flex align-items-center" class="w-100 py-1" [disabled]="summaryLoading"
                                style="font-size: 12px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;"
                                (click)="toggleSummary()">
                                <span>{{ isSummaryExpanded ? 'View less' : 'View more' }}</span> <i class="bi ml-1"
                                    [ngClass]="isSummaryExpanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    

    <div class="bg-white" style="padding: 8px 8px 25vh; min-height: 85vh;">
        
        <div class="list-container" infinite-scroll
            [infiniteScrollDistance]="scrollDistance" [infiniteScrollUpDistance]="scrollUpDistance"
            [infiniteScrollThrottle]="throttle" (scrolled)="onScroll()" style="overflow-y: auto;">

            <ng-container *ngIf="loading; else realContent">
                <div class="serviceItem d-flex p-2 my-3" *ngFor="let _ of [].constructor(5)">
                    <!-- Left Job Box -->
                    <div class="mr-2">
                        <div class="jobBox d-flex flex-column align-items-center justify-content-center p-2 skeleton-box"
                            style="width:80px; height:90px;">
                
                            <div class="skeleton-text very-short mb-1"></div>
                            <div class="d-flex align-items-center">
                                <div class="skeleton-text very-short"></div>
                            </div>
                
                        </div>
                    </div>
                
                    <!-- Right Content -->
                    <div class="row no-gutters w-100" style="overflow: hidden;">
                        <div class="d-flex align-items-center justify-content-between w-100">
                
                            <!-- Left Text Block -->
                            <div class="d-flex flex-column w-75">
                                <div class="skeleton-text short mb-1"></div>
                                <div class="skeleton-text very-short mb-1"></div>
                                <div class="skeleton-text short"></div>
                            </div>
                
                            <!-- Right Amount Block -->
                            <div class="d-flex flex-column align-items-end w-25">
                                <div class="skeleton-text very-short mb-1"></div>
                                <div class="skeleton-text short mb-1"></div>
                
                                <div class="skeleton-text very-short mb-1"></div>
                                <div class="skeleton-text short"></div>
                            </div>
                
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #realContent>
                <div *ngIf="salesData.length==0" class="no-data-message text-center ">
                    No sales list data found.
                </div>
                <ng-container *ngIf="salesData.length!=0"> 
                    <div class="serviceItem d-flex p-2 my-3" *ngFor="let item of salesData">
                        <div class="mr-2">
                            <div class="jobBox d-flex flex-column align-items-center justify-content-center p-2 ">
                                <div class="bill">{{item?.BillNo}}</div>
                                <hr class="w-100">
                                <div class="d-flex align-items-center">
                                    <div class="productLabel">Items:</div>
                                    <div class="text-center jobNumber ml-1"> {{item?.NumberOfOrders}}</div>
                                </div>
                            </div>
                        </div>
        
                        <div class="row no-gutters w-100" style="overflow: hidden;">
                           
                            <div class="d-flex align-items-center justify-content-between w-100 ">
                                <div class="d-flex flex-column ">
                                    <div class="customerName mb-1">
                                        {{item?.ShopName}}
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between w-100">
                                        <div class="totalAmount">
                                            <strong>{{item?.OrderNumber}}</strong>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between w-100">
                                        <div class="paidAmount text-secondary" style="font-size: 13px;">
                                            {{formatUnixToReadable(item?.CreatedOnUnix)}}
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column ">
                                    <div class="d-flex flex-column align-items-end">
                                        <div style="font-size: 12px; color: #757575;">Total Amt</div>
                                        <div style="font-size: 14px; font-weight: 600;">{{item?.FinalPrice | currency : 'INR' : 'symbol' : '1.0-0'}}</div>
                                    </div>
        
                                    <div class="d-flex flex-column align-items-end">
                                        <div style="font-size: 12px; color: #757575;">Net Profit</div>
                                        <div style="font-size: 14px; font-weight: 600;">{{item?.NetProfit | currency : 'INR' : 'symbol' : '1.0-0'}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-template>

        </div>
    </div>
</div>